import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgDeliveryVanFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 17h-4a3 3 0 1 1-6 0 2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1h2a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 22 12v4a1 1 0 0 1-1 1h-1a3 3 0 1 1-6 0Zm5.236-2c-.55-.614-1.348-1-2.236-1-.768 0-1.47.289-2 .764V13h5v2h-.764ZM15 11V9h1.586l2 2H15Zm-8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z", fill: color }));
};
export default factorySvgIcon(SvgDeliveryVanFilled);
//# sourceMappingURL=SvgDeliveryVanFilled.js.map